export function calculateDaysHoursMinutes(initialSeconds) {
  const secondsNum = parseInt(initialSeconds, 10);

  return {
    days: Math.floor(secondsNum / 86400),
    hours: Math.floor(secondsNum / 3600) % 24,
    minutes: Math.floor(secondsNum / 60) % 60,
  };
}
